import React from "react";
import Popup from "../../components/Popup";
import type { InitiatorTrustPayload } from "../Contracts/ContractView/InitiatorTrustBanner";
import InitiatorTrustChecklist from "../Contracts/ContractView/InitiatorTrustChecklist";
import {
    getEntrepreneurRegistryFailureUserHint,
    getInitiatorTrustFixActions,
    type InitiatorTrustFixAction,
    type InitiatorTrustSettings,
} from "../Contracts/ContractView/initiatorTrustCriteria";
import { maxSupportLink, openInNewTab, supportLink } from "../../methods/openInNewTab";
import "pages/Styles/UIKit_v2.sass";

type Props = {
    trust: InitiatorTrustPayload;
    onClose: () => void;
    onAction: (action: InitiatorTrustFixAction) => void;
    selfieDisplayMode?: string;
    trustSettings?: Partial<InitiatorTrustSettings> | null;
    onOpenSelfieVerify?: () => void;
    showSelfieVerify?: boolean;
    selfieButtonLabel?: string;
};

export default function InitiatorTrustProfilePopup({
    trust,
    onClose,
    onAction,
    selfieDisplayMode,
    trustSettings,
    onOpenSelfieVerify,
    showSelfieVerify,
    selfieButtonLabel,
}: Props) {
    const actions = getInitiatorTrustFixActions(trust);
    const registryFailureHint = getEntrepreneurRegistryFailureUserHint(trust);

    return (
        <Popup onClose={onClose} maxWidth="560px">
            <div style={{ padding: "8px 4px 24px" }}>
                <h2 className="Subheader_18" style={{ marginBottom: 16 }}>
                    Как вас видят подписанты
                </h2>
                <p className="cell-card-meta" style={{ marginBottom: 16, color: "#4B5563" }}>
                    При открытии договора подписант видит эту справочную проверку. Улучшите показатели,
                    которые зависят от данных профиля.
                </p>

                {trust.status === "pending" && (
                    <p className="cell-card-meta" style={{ marginBottom: 16 }}>
                        Проверка выполняется. Это может занять до минуты.
                    </p>
                )}

                {trust.status === "ready" && trust.customer?.selfie_check === "PENDING" && (
                    <p className="cell-card-meta" style={{ marginBottom: 16 }}>
                        Проверка селфи выполняется. Обычно до нескольких минут — пришлём уведомление
                        о результате.
                    </p>
                )}

                {registryFailureHint && (
                    <div
                        className="cell-card-meta"
                        style={{
                            marginBottom: 16,
                            padding: "12px 14px",
                            borderRadius: 8,
                            background: "#FFF8E1",
                            color: "#5D4037",
                            lineHeight: 1.45,
                        }}
                    >
                        <div>{registryFailureHint}</div>
                        <div style={{ marginTop: 10 }}>
                            Если считаете, что это ошибка — напишите нам в техподдержку:
                        </div>
                        <div
                            style={{
                                marginTop: 10,
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8,
                            }}
                        >
                            <button
                                type="button"
                                className="action-button secondary"
                                style={{ flex: "1 1 140px" }}
                                onClick={() => openInNewTab(supportLink())}
                            >
                                <span className="button-text">Telegram</span>
                            </button>
                            <button
                                type="button"
                                className="action-button secondary"
                                style={{ flex: "1 1 140px" }}
                                onClick={() => openInNewTab(maxSupportLink())}
                            >
                                <span className="button-text">MAX</span>
                            </button>
                        </div>
                    </div>
                )}

                {trust.status === "ready" && (
                    <>
                        <div className="Subheader_14" style={{ marginBottom: 10 }}>
                            Критерии проверки
                        </div>
                        <InitiatorTrustChecklist
                            trust={trust}
                            iconSize={22}
                            selfieDisplayMode={selfieDisplayMode}
                            viewerIsOwner
                            trustSettings={trustSettings}
                        />
                    </>
                )}

                {actions.length > 0 && (
                    <div
                        className="buttons-container-v2"
                        style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 10 }}
                    >
                        {actions.map((action) => (
                            <button
                                key={action.id}
                                type="button"
                                className="action-button primary"
                                onClick={() => onAction(action)}
                            >
                                <span className="button-text">{action.label}</span>
                            </button>
                        ))}
                    </div>
                )}

                {showSelfieVerify && onOpenSelfieVerify && (
                    <div
                        className="buttons-container-v2"
                        style={{ marginTop: actions.length > 0 ? 10 : 24, display: "flex", flexDirection: "column", gap: 10 }}
                    >
                        <button
                            type="button"
                            className="action-button primary"
                            onClick={onOpenSelfieVerify}
                        >
                            <span className="button-text">{selfieButtonLabel ?? "Проверить селфи с паспортом"}</span>
                        </button>
                    </div>
                )}
            </div>
        </Popup>
    );
}
